import { number } from "../../config";

/**
 * Validates if a user can be modified based on their role and team ownership
 * @author Bhavana
 */
export const checkUserValidation = ({ roleId, projectMembersLength, teamMember }) => {
  const validateUser = parseInt(roleId) === number.FOUR;
  return (validateUser && projectMembersLength > number.ONE) || (validateUser && projectMembersLength === number.ONE && teamMember.RoleId !== number.FOUR);
};
